<template>
  <div class="nouveaux needResize" :class="{'fullscreen': fullscreen}">
    <Info @fullscreen="onFullScreen" title="nouveaux.title" text="nouveaux.info" ></Info>
    <div class="title">
      <h3>{{$t('nouveaux.title')}}</h3>
    </div>
    <div class="main-content"  v-if="display">
      <chartist id="new" ref="chartNouveau" :data="chartData" :options="chartOptions" type="Pie" :event-handlers="eventHandlers"></chartist>
      <div class="total-clients">{{this.totalClient | splitNumber}} <br> <span class="font-client">{{$t('nouveaux.clients')}}</span></div>
    </div>
    <ul class="point-legends" v-if="display">
      <li>
        <div class="point point1"></div>
        <div>{{$t('nouveaux.oldClients')}}</div>
        <div style="font-weight:bold;">{{chartData.series[1] | splitNumber}} ({{percentage(1)}}%)</div>
      </li>
      <li>
        <div class="point point2"></div>
        <div>{{$t('nouveaux.newClients')}}</div>
        <div style="font-weight:bold;">{{chartData.series[0] | splitNumber}} ({{percentage(0)}}%)</div>
      </li>
    </ul>
    <div v-else>
      <br/>
      {{$t('nouveaux.textWhenNoEndDateAndStartDate')}}
    </div>
  </div>
</template>

<script>
  import Info from './Info.vue'
  export default {
    name: 'Nouveaux',
    components: {
      Info
    },
    props: {
      result: Object, 
      display: Boolean, 
      nbOfColumns: Number
    },
    watch: {
      result(new_value, old_value) {
        this.refresh()
      }, 
      nbOfColumns() {
        this.refresh()
      }
    },
    created() {
      let that = this
      this.eventHandlers = [{event:'created', fn() {that.$emit("refreshedChart")}}]
    },
    data() {
      return {
        fullscreen: false,
        chartOptions: {
          donut: true,
          donutWidth: 10,
          donutSolid: true,
          startAngle: 0,
          showLabel: false,
        },
        myHeight: 0,
        myWidth: 0, 
        eventHandlers: []
      }
    },
    computed: {
      chartData() {
        let oldcustomers = 0
        let newcustomers = 0
        if (this.result && this.result.hits && this.result.aggregations.new) {
          newcustomers = this.result.aggregations.new.doc_count
          oldcustomers = this.result.hits.total - newcustomers
        }
        return {series: [newcustomers, oldcustomers]}
      }, 
      totalClient() {
        return this.chartData.series[0] + this.chartData.series[1]
      }
    },
    methods: {
      percentage(index) {
        if (this.chartData.series[0] + this.chartData.series[1] === 0) {
          return 0
        }
        return (Math.round(this.chartData.series[index] * 100 / (this.chartData.series[0] + this.chartData.series[1]) * 10) / 10).toLocaleString()
      },
      onFullScreen() {
        if(this.myHeight == 0) {
          this.myHeight = document.getElementById('new').clientHeight - 4
          this.myWidth = document.getElementById('new').clientWidth
        }
        this.fullscreen = !this.fullscreen
        if (this.fullscreen) {
          this.chartOptions.width = "40vw"
          this.chartOptions.height = "40vh"
        } else {
          this.chartOptions.width = `${this.myWidth}px`
          this.chartOptions.height = `${this.myHeight}px`
        }
        this.$refs.chartNouveau.redraw()
      }, 
      refresh() {
        if (this.$refs.chartNouveau) {
          this.$refs.chartNouveau.redraw()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/nouveaux.sass"
</style>
